var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cookie-consent grid grid__base" }, [
    _c("div", { staticClass: "grid--row" }, [
      _c(
        "div",
        { staticClass: "cookie-consent--input-col grid--col" },
        [
          _c("form-field-toggle", {
            attrs: {
              id: _vm.value,
              value: _vm.isChecked,
              state: { disabled: _vm.disabled },
              label: _vm.label
            },
            on: { input: _vm.onChange }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cookie-consent--text-col grid--col" },
        [_vm._t("default")],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c171824a", { render: render, staticRenderFns: staticRenderFns })
  }
}